import { Post } from "posts/posts.types"
import { loadSuccessAction, updateSuccessAction } from "state/actions/crud_actions"

export const updateDraftAction = (result: Post) => {
    return updateSuccessAction("draft", result)
}

export const updatePostAction = (result: Post) => {
    return updateSuccessAction("post", result)
}

export const updateResponsesAction = (result: Post, opts) => {
    return loadSuccessAction("responses", result, opts)
}